import { ActivatedRoute, Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { environment } from '../environments/environment';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { TranslateService } from '@ngx-translate/core';
import { Injector } from '@angular/core';
import { LOCATION_INITIALIZED } from '@angular/common';
import { UserService } from './core/services/user.service';
import { AppConfigService } from './app-config.service';

export function keycloakFactory(
  keycloak: KeycloakService,
  userService: UserService,
  router: Router,
  configApp: AppConfigService
): () => Promise<any> {
  return (): Promise<any> => {
    return new Promise<void>(async (resolve, reject) => {

      const url = new URL(window.location.href);
      const realm = url.pathname.split('/')[1];
      const login = url.pathname.split('/')[3];

      if (
        realm == 'register' ||
        realm == 'register-info' ||
        realm == 'register-antifraud' ||
        realm == 'register-pix' ||
        realm == 'config-service' ||
        realm == 'src' ||
        login == 'google'
      ) {
        resolve();
      } else {
        if (!realm) {
          router.navigateByUrl('');
          resolve();
        }
        await configApp.loadAppConfig();
        var keycloakConfig = configApp.getConfig();
        try {
          await keycloak
            .init({
              config: {
                url: keycloakConfig.url,
                clientId: keycloakConfig.clientId,
                realm,
              },
              initOptions: {
                onLoad: 'login-required',
                checkLoginIframe: false,
              },
              bearerExcludedUrls: [],
            })
            .then(async (authenticated: boolean) => {

              if (!authenticated) return;
              await userService.setUser();
            })
            .catch();
          resolve();
        } catch (error) {
          reject(error);
        }
      }
    });
  };
}

export function initConfigFactory(
  appConfig: AppConfigService
): () => Promise<any> {
  return (): Promise<any> => {
    return appConfig.loadAppConfig();
  };
}


export function httpLoaderFactory(http: HttpBackend) {
  return new MultiTranslateHttpLoader(http, [
    { prefix: './assets/resources/layout/breadcrumb/', suffix: '.json?v=' + Date.now() },
    { prefix: './assets/resources/layout/enter/', suffix: '.json?v=' + Date.now() },
    { prefix: './assets/resources/layout/register/', suffix: '.json?v=' + Date.now() },
    { prefix: './assets/resources/layout/menu/', suffix: '.json?v=' + Date.now() },
    { prefix: './assets/resources/layout/modal-alert/', suffix: '.json?v=' + Date.now() },
    { prefix: './assets/resources/layout/modal-confirm-reports/', suffix: '.json?v=' + Date.now() },
    { prefix: './assets/resources/layout/search/', suffix: '.json?v=' + Date.now() },
    { prefix: './assets/resources/layout/pagination/', suffix: '.json?v=' + Date.now() },
    { prefix: './assets/resources/layout/custom-dropdown/', suffix: '.json?v=' + Date.now() },
    { prefix: './assets/resources/layout/toast/', suffix: '.json?v=' + Date.now() },
    { prefix: './assets/resources/layout/file-upload/', suffix: '.json?v=' + Date.now() },
    { prefix: './assets/resources/layout/footer/', suffix: '.json?v=' + Date.now() },
    { prefix: './assets/resources/contexts/transactions/', suffix: '.json?v=' + Date.now() },
    { prefix: './assets/resources/contexts/messages/', suffix: '.json?v=' + Date.now() },
    { prefix: './assets/resources/contexts/services/', suffix: '.json?v=' + Date.now() },
    { prefix: './assets/resources/contexts/flows/', suffix: '.json?v=' + Date.now() },
    { prefix: './assets/resources/contexts/settings/', suffix: '.json?v=' + Date.now() },
    { prefix: './assets/resources/contexts/partners/', suffix: '.json?v=' + Date.now() },
    { prefix: './assets/resources/contexts/dashboard/', suffix: '.json?v=' + Date.now() },
    { prefix: './assets/resources/contexts/merchants/', suffix: '.json?v=' + Date.now() },
    { prefix: './assets/resources/contexts/financial-transfer/', suffix: '.json?v=' + Date.now() },
    { prefix: './assets/resources/core/validator/', suffix: '.json?v=' + Date.now() },
    { prefix: './assets/resources/core/fields/options/', suffix: '.json?v=' + Date.now() },
    { prefix: './assets/resources/core/features/', suffix: '.json?v=' + Date.now() },
    { prefix: './assets/resources/contexts/payment-links/', suffix: '.json?v=' + Date.now() },
    { prefix: './assets/resources/contexts/welcome/', suffix: '.json?v=' + Date.now() },
    { prefix: './assets/resources/contexts/connections/', suffix: '.json?v=' + Date.now() },
    { prefix: './assets/resources/contexts/transfer/', suffix: '.json?v=' + Date.now() },
    { prefix: './assets/resources/contexts/authorization/', suffix: '.json?v=' + Date.now() },

  ]);
}

export function translateFactory(
  translate: TranslateService,
  injector: Injector,
  keycloak: KeycloakService
) {
  return () =>
    new Promise<any>((resolve: any) => {
      const locationInitialized = injector.get(
        LOCATION_INITIALIZED,
        Promise.resolve(null)
      );
      locationInitialized.then(() => {
        const langToSet = 'pt-br';
        const browserCultureLang = translate
          .getBrowserCultureLang()
          .toLocaleLowerCase();
        // translate.use(langToSet);
        translate
          .use(
            browserCultureLang.match(/pt-br|es-es|en-us/)
              ? browserCultureLang
              : langToSet
          )
          .subscribe(
            () => { },
            () => { },
            () => {
              resolve(null);
            }
          );
      });
    });
}
